export default __webpack_public_path__ + "static/media/slide5.0d76f3e8.webp";